// TermsOfService.tsx
import React from 'react';
import abraLogo from '../../assets/abra-logo.png';

export default function TermsOfService() {
  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1 className="dashboard-title">
          <img src={abraLogo} alt="Abra Logo" className="logo" />
          Console
        </h1>
      </header>

      <div className="dashboard-content" style={{ maxWidth: '800px', margin: '2rem auto', padding: '2rem' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Terms of Service</h2>
        <p>Effective Date: Apr. 28, 2025</p>
        <p>Last Updated: Apr. 28, 2025</p>

        <p>These Terms of Service ("Terms") govern your access to and use of Abra Console ("the Service") at https://console.abra-actions.com. By using the Service, you agree to these Terms.</p>

        <h3>1. Eligibility</h3>
        <p>You must be 16 years or older to use the Service.</p>

        <h3>2. Account Registration</h3>
        <p>You may sign in using Google, GitHub, or email. You are responsible for your account credentials and any activity under your account.</p>

        <h3>3. Acceptable Use</h3>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>No spam, hacking, or illegal activity.</li>
          <li>No multiple accounts for a single person or business.</li>
        </ul>

        <h3>4. API Usage</h3>
        <p>Free-tier users receive 200,000 tokens per month. Abuse or excessive use may result in account suspension.</p>

        <h3>5. Modifications & Termination</h3>
        <p>We may modify or discontinue any part of the Service at any time. We reserve the right to suspend or terminate accounts violating these Terms.</p>

        <h3>6. No Warranty</h3>
        <p>The Service is provided "as is" with no guarantees of uptime or accuracy.</p>

        <h3>7. Future Features</h3>
        <p>The Service is currently free. Paid features may be introduced later.</p>

        <h3>8. Governing Law</h3>
        <p>These Terms are governed by the laws of New York, USA.</p>

        <p style={{ marginTop: '2rem', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
          Contact: hello@abra-actions.com
        </p>
      </div>
    </div>
  );
}
